// Display currency symbol for the logged-in shop ("$" default, Leyenda → "¥"). Display only.
let _sym = (() => { try { return localStorage.getItem("sx_cur_sym") || "$"; } catch { return "$"; } })();
export const curSym = () => _sym;
export const cur = curSym;
export const setCurSym = (s) => {
  const next = (s || "$").trim().slice(0, 3) || "$";
  if (next === _sym) return;
  _sym = next;
  try { localStorage.setItem("sx_cur_sym", _sym); } catch { /* ignore */ }
  try { window.dispatchEvent(new Event("sx-cur-change")); } catch { /* ignore */ }
};
